"use client";

import { ICONS_MODULES_PATHS } from "components/Layout/Sidebar/components/body/content/utils/iconModulesPath";
import { ExploreRankingModalV2 } from "components/ui/v2/explore/ExploreRankingModalV2";
import { UserItemRanking } from "components/ui/v2/explore/bundle/SideCard/UserItemRanking";
import useTranslation from "next-translate/useTranslation";
import { useMemo } from "react";
import { EModalExploreType } from "types/Explorer.types";
import { IUser } from "types/User.types";

export interface CoinsRankingModalV2Props {
  open: boolean;
  onClose: () => void;
  data: IUser[];
}

export function CoinsRankingModalV2({
  open,
  onClose,
  data,
}: CoinsRankingModalV2Props) {
  const { t } = useTranslation("common");

  const description = useMemo(() => {
    if (data.length === 0) return undefined;
    return `${data.length} ${t("usuarios")}`;
  }, [data.length, t]);

  return (
    <ExploreRankingModalV2
      open={open}
      onClose={onClose}
      title={t("Ranking de Coins")}
      iconSrc={ICONS_MODULES_PATHS.MARKETPLACE.COINS_MODULE}
      description={description}
    >
      <div className="flex flex-col gap-1">
        {data.map((r) => (
          <UserItemRanking
            key={`${r.id}_coins_modal`}
            data={r}
            quantity={r.coinsHistoricallyReceived}
            type={EModalExploreType.COINS}
          />
        ))}
      </div>
    </ExploreRankingModalV2>
  );
}

export default CoinsRankingModalV2;
